<template>
  <w-flex justify-center align-center v-if="$zutil.role('Al Man') && ind == 1">
    <div class="w-card__content content-hardcode">
        <w-flex class="mt3">
         <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
         </w-button>
       </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Tarikh</th>
          <th class="w-table__header  text-left">Baka</th>
          <th class="w-table__header  text-left">Jantan</th>
          <th class="w-table__header  text-left">Jenis</th>
          <th class="w-table__header  text-left">Semen/Embrio</th>
          <th class="w-table__header  text-left">Al Man</th>
          <th class="w-table__header  text-left">Status</th>
          <th class="w-table__header  text-left">Tindakan</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >
              <template v-if="dt.pemeriksaan_id">
                <inertia-link :href="$route('pemeriksaan.show',dt.pemeriksaan_id)" >{{dt.tarikh}}</inertia-link>
              </template>
              <template v-else>
                {{dt.tarikh}}
              </template>
            </td>
            <td class="w-table__cell text-left" >{{dt.baka}}</td>
            <td class="w-table__cell text-left" >{{dt.jantan}}</td>
            <td class="w-table__cell text-left" >{{dt.jenis == 2 ? 'TE' : 'AI'}}</td>
            <td class="w-table__cell text-left" >
              <template v-if="dt.jenis == 2"><inertia-link :href="$route('embrio.show',dt.embrio_id)" >{{dt.kode}}</inertia-link></template>
              <template v-else><inertia-link :href="$route('baka.show',dt.baka_id)" >{{dt.kode}}</inertia-link></template>
          </td>
            <td class="w-table__cell text-left" >{{dt.user}}</td>
            <td class="w-table__cell text-left" >{{dt.status}}</td>
            <td class="w-table__cell text-left" >
              
              <inertia-link :href="$route('baka.show',dt.id)" class="w-button black  info-dark1--bg size--md be fs-2"> 
                <w-icon xs class="mr2">fal fa-eye</w-icon>  Papar
              </inertia-link>
              &nbsp;
              <w-button dark class="green--bg ml1" @click="pemeriksaan(dt)" v-if="dt.lkp_status_id == 11 && $zutil.role('Al Man')">
                 <w-icon class="mr1">fal fa-pencil</w-icon> Pemeriksaan
             </w-button>
             <w-button dark class="green--bg ml1" @click="tindakan(dt)" v-if="dt.lkp_status_id == 12 && $zutil.role('Al Man')">
                 <w-icon class="mr1">fal fa-pencil</w-icon> Tindakan
             </w-button>
             <w-button dark class="green--bg ml1" @click="tindakan(dt)" v-if="dt.lkp_status_id == 12 && $zutil.role('Penternak') && $page.props.auth.user.id == data.user_id">
                 <w-icon class="mr1">fal fa-pencil</w-icon> Tindakan
             </w-button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Inseminasi
    </template>
    <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
      <z-input label="Tarikh *" type="date" v-model="form.tarikh"  :validators="[validators.required]" />

      <w-select :items="insemination_jenis" label="Jenis *"  v-model="form.jenis"  :validators="[validators.required]"/>
      <template v-if="form.jenis == 1">
        <w-select :items="lkp_baka" label="Baka *"  v-model="form.lkp_baka_id" @input="getStraw(form.lkp_baka_id)" :validators="[validators.required]"/>
        <w-select :items="baka_straw" label="Straw *"  v-model="form.baka_straw_id"  :validators="[validators.required]"/>
      </template>
      <template v-if="form.jenis == 2">
        <w-select :items="lkp_baka" label="Baka *"  v-model="form.lkp_baka_id" @input="getEmbrio(form.lkp_baka_id)" :validators="[validators.required]"/>
        <w-select :items="embrio" label="Embrio *"  v-model="form.embrio_id"  :validators="[validators.required]"/>
      </template>
      
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog.loading" @click="$refs.form.validate()">Simpan</w-button>
    </template>
  </w-dialog>

  <w-dialog v-model="dialog_insemination.show" :fullscreen="dialog_insemination.fullscreen" :width="dialog_insemination.width" :persistent="dialog_insemination.persistent"  :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Pemeriksaan
    </template>
    <w-form  ref="form_insemination"  v-model="dialog_insemination.valid" @validate="submitPemeriksaan" @success="success" >
      <w-select :items="status_insemination" label="Status *"  v-model="form_insemination.lkp_status_id"  :validators="[validators.required]"/>
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog_insemination.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog_insemination.loading" @click="$refs.form_insemination.validate()">Simpan</w-button>
    </template>
  </w-dialog>

  <w-dialog v-model="dialog_kehamilan.show" :fullscreen="dialog_kehamilan.fullscreen" :width="dialog_kehamilan.width" :persistent="dialog_kehamilan.persistent"  :persistent-no-animation="dialog_kehamilan.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Tindakan
    </template>
    <w-form  ref="form_kehamilan"  v-model="dialog_kehamilan.valid" @validate="submitTindakan" @success="success" >
      <w-select :items="status_kehamilan" label="Status *"  v-model="form_kehamilan.lkp_status_id"  :validators="[validators.required]"/>
      <template v-if="form_kehamilan.lkp_status_id == 14">
        <w-select :items="jantina" label="Jantina *"  v-model="form_kehamilan.jantina"  :validators="[validators.required]"/>
        <z-input label="Tarikh Lahir*" type="date" v-model="form_kehamilan.tarikh_lahir"  :validators="[validators.required]" />
      </template>
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog_kehamilan.show = false">Tutup</w-button>
      <w-button class="ml1" :loading="dialog_kehamilan.loading" @click="$refs.form_kehamilan.validate()">Simpan</w-button>
    </template>
  </w-dialog>


</template>

<script>
export default {
  name: "Insemination",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      
      datas : [],
      lkp_baka : [],
      baka_straw : [],
      embrio : [],
      status_insemination : [],
      status_kehamilan : [],
      jantina : [],
      insemination_jenis : [],
      ind : 1,
      form : {
        lkp_baka_id : '',
        baka_straw_id : '',
        tarikh : '',
      },
      form_insemination : {
        lkp_status_id : '',
        ternakan_insemination_id : ''
      },
      form_kehamilan : {
        lkp_status_id : '',
        ternakan_insemination_id : '',
        tarikh_lahir : '',
        jantina : '',
      },
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      dialog_insemination: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      dialog_kehamilan: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },
      validators: {
        required: value => !!value || 'Wajib Isi.',
        
      }, 
      
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/insemination/'+this.data.id, {}).then(res => {
        this.datas = res.datas
        this.ind =  res.ind
      })
    },
    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },
    getInseminationJenis(){
      this.$zcomm.get(this.api_service + 'lookup/insemination_jenis', {}).then(res => {
        this.insemination_jenis = res
      })
    },
    getStatusInsemination(){
      this.$zcomm.get(this.api_service + 'lookup/status_insemination', {}).then(res => {
        this.status_insemination = res
      })
    },
    getStatusKemahilan(){
      this.$zcomm.get(this.api_service + 'lookup/status_kehamilan', {}).then(res => {
        this.status_kehamilan = res
      })
    },
    getBaka(){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+this.data.lkp_ternakan_id, {}).then(res => {
        this.lkp_baka = res
      })
    },
    getStraw(i){
      
      this.$zcomm.get(this.api_service + 'lookup/straw/'+i, {}).then(res => {
        this.baka_straw = res
      })
    },

    getEmbrio(i){
      
      this.$zcomm.get(this.api_service + 'lookup/embrio/'+i, {}).then(res => {
        this.embrio = res
      })
    },
    add(){
      this.dialog.show = true
      this.form = {
        lkp_baka_id : '',
        baka_straw_id : '',
        tarikh : '',
      }
    },

    pemeriksaan(dt){
      
      this.dialog_insemination.show = true
      this.form_insemination = {
        ternakan_insemination_id : dt.id,
        lkp_status_id : ''
      }
    },

    tindakan(dt){
      
      this.dialog_kehamilan.show = true
      this.form_kehamilan = {
        ternakan_insemination_id : dt.id,
        lkp_status_id : '',
        tarikh_lahir : '',
        jantina : '',
      }
    },

    submit() {
      if(this.form.tarikh && this.form.lkp_baka_id > 0 && (this.form.baka_straw_id > 0 || this.form.embrio_id > 0)){
        this.form.ternakan_id = this.data.id
        this.form.lkp_ternakan_id = this.data.lkp_ternakan_id
        this.form.lkp_status_id = 11
        this.$zcomm.add( 'insemination.ternakan.store', this.form)
        .then(res => {
          
          this.dialog.show = false;
          this.getData()
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    },

    submitPemeriksaan() {
      if(this.form_insemination.lkp_status_id){
        this.form_insemination.ternakan_id = this.data.id
        this.$zcomm.add( 'insemination.ternakan.pemeriksaan', this.form_insemination)
        .then(res => {
          
          this.dialog_insemination.show = false;
          this.$inertia.visit(this.$page.url)
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    },

    submitTindakan() {
      if((this.form_kehamilan.lkp_status_id == 14 && this.form_kehamilan.jantina && this.form_kehamilan.tarikh_lahir) || (this.form_kehamilan.lkp_status_id  == 15)){
        this.form_kehamilan.ternakan_id = this.data.id
        this.$zcomm.add( 'insemination.ternakan.tindakan', this.form_kehamilan)
        .then(res => {
          
          this.dialog_insemination.show = false;
          this.$inertia.visit(this.$page.url)
        })
        .finally(() => {
            this.dialog.loading = false;

        });
      }
    }
  },
      
  mounted() {
    this.getData()
    this.getBaka()
    this.getJantina()
    this.getInseminationJenis()
    this.getStatusInsemination()
    this.getStatusKemahilan()
    
  }
}
      

</script>  
